import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ComingSoonChip() {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('article.upcoming')} placement='top'>
      <Chip
        label={t('article.upcomingShort')}
        color='default'
        size='small'
        sx={{
          color: 'text.secondary',
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
        }}
      />
    </Tooltip>
  );
}
